export const computeBudgetPercentages = (values: number[], total: number): number[] => {
  if (!total) {
    return values.map(() => 0);
  }

  const percentages = values.map(value => Math.round((value * 100) / total));
  const diff = 100 - percentages.reduce((sum, percentage) => sum + percentage, 0);

  if (diff) {
    const maxIndex = percentages.indexOf(Math.max(...percentages));
    percentages[maxIndex] += diff;
  }

  return percentages;
};
